import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import AsyncIcon from '@atlassian/jira-common-components-async-icon';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export type Props = {
	issueTypeIconUrl: string;
	issueTypeName: string;
};

export const View = ({ issueTypeIconUrl, issueTypeName }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<Tooltip
			position="top"
			content={formatMessage(messages.uneditableIssueType, {
				issueTypeName,
			})}
			truncate
			delay={0}
			testId="issue-view-foundation.noneditable-issue-type.tooltip"
		>
			<ButtonContainer>
				<Button
					spacing="compact"
					appearance="subtle"
					iconBefore={<AsyncIcon url={issueTypeIconUrl} alt={issueTypeName} />}
					isDisabled
					interactionName="auto-generated.jira-issue-view-foundation.noneditable-issue-type.button"
					testId="issue-view-foundation.noneditable-issue-type.button"
				/>
			</ButtonContainer>
		</Tooltip>
	);
};

export default View;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonContainer = styled.div({
	cursor: 'not-allowed',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> button': {
		pointerEvents: 'none',
	},
});
